export const MAXIMUM_QUANTITY = 100_000_000;
export const MAXIMUM_PACK_QUANTITY = MAXIMUM_QUANTITY / 100;
export const MAX_PRODUCT_PRICE = MAXIMUM_QUANTITY / 100;
export const MAX_TOTAL_PRICE = MAXIMUM_QUANTITY;
export const MAX_DISCOUNT = 99.999;
